import { Flag } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const FlagIcon = createLucideIcon(Flag);
